<template>
    <div class="modal" :style="{ 'zIndex':comp.zIndex }">
        <div class="modal-close" @click="comp.hideView()"></div>
        <div class="modal-pop">
            <div class="close" @click="comp.hideView()"><i class="lar la-times-circle"></i></div>
            <div class="modal-body">
                <div class="ex-box result-box">
                    <!-- pitch analysis chart -->
                    <div class="chart">
                        <PitchChart :width="comp.pitch.w" :height="comp.pitch.h" :labels="comp.pitch.labels" :datalist="comp.pitch.datalist"></PitchChart>
                    </div>

                    <!-- pitch original analysis chart -->
                    <div class="chart" style="margin-top:10px" v-if="comp.uidx==20281">
                        <PitchChart :width="comp.pitch_o.w" :height="comp.pitch_o.h" :labels="comp.pitch_o.labels" :datalist="comp.pitch_o.datalist"></PitchChart>
                    </div>

                    <!-- intensity analysis chart -->
                    <div class="chart" style="margin-top:10px">
                        <IntensityChart :width="comp.intensity.w" :height="comp.intensity.h" :labels="comp.intensity.labels" :datalist="comp.intensity.datalist"></IntensityChart>
                    </div>

                    <div>
                        <div class="tit">[Result]</div>
                        <span class="script">
                            <span class="speech">SCORE : {{ comp.view.avg_score.toFixed(1) }}</span>
                            <span class="speech">GRADE : <span class="speech" :class="comp.view.avg_grade">{{ comp.view.avg_grade }}</span></span>
                            <span class="speech">Speech Time : {{ (comp.view.len_tot/1000).toFixed(2) }}s</span>
                            <span class="speech">WPM : {{ (comp.view.words_cnt/((comp.view.len_tot/1000)/60)).toFixed(2) }}w/m</span>
                        </span>
                        <div class="tit">[Script]</div>
                        <span>
                            <span>{{ comp.view.text }}</span>
                            <button type="button" class="btn btn-play" @click="comp.onPlay(comp.view)">
                                <i v-if="comp.play.idx==comp.view.idx" class="las la-volume-up"></i>
                                <i v-else class="las la-play"></i>
                            </button>
                        </span><br>
                        <template v-for="(irow, i) in comp.view.phonemes" :key="i">
                            <span :score="irow.score" :class="{ 'hover':comp.view.hover==i }"><span :class="comp.mkClass(comp.view, i)" @mouseover="comp.onHover(i)" @mouseleave="comp.onHover(-1)" @click="comp.onSelect(i)">{{ irow.token_txt }}</span></span>
                        </template>
                    </div>

                    <div>
                        <div class="tit">[Pronunciation]</div>
                        <template v-for="(irow, i) in comp.view.phonemes" :key="i">
                            <span :class="{ 'hover':comp.view.hover==i }"><span :class="comp.mkClass(comp.view, i)" @mouseover="comp.onHover(i)" @mouseleave="comp.onHover(-1)" @click="comp.onSelect(i)">{{ irow.pron_txt }}</span></span>
                        </template><br>
                        <template v-for="(irow, i) in comp.view.phonemes" :key="i">
                            <span :score="irow.score" :class="{ 'hover':comp.view.hover==i }"><span :class="comp.mkClass(comp.view, i)" @mouseover="comp.onHover(i)" @mouseleave="comp.onHover(-1)" @click="comp.onSelect(i)">{{ irow.stress>'0.0'?irow.token_txt.toUpperCase():irow.token_txt.toLowerCase() }}</span></span>
                        </template>
                    </div>
                    <div>
                        <div class="tit">[Token]</div>
                        <template v-for="(irow, i) in comp.view.phonemes" :key="i">
                            <span v-if="i>0"><span>·</span></span>
                            <span :score="irow.score" :class="{ 'hover':comp.view.hover==i }"><span :class="comp.mkClass(comp.view, i)" @mouseover="comp.onHover(i)" @mouseleave="comp.onHover(-1)" @click="comp.onSelect(i)">{{ irow.token }}</span></span>
                        </template>
                    </div>
                </div>
            </div>

            <div class="ex-pron" v-if="comp.phoneme.show">
                <div class="ex-bg" @click="comp.deSelect()"></div>
                <div class="ex-box">
                    <button class="btn-ex-close" @click="comp.deSelect()"><i class="lar la-times-circle"></i></button>
                    <table>
                        <tr>
                            <th rowspan="2">Phoneme<br>Pronunciation</th>
                            <th :colspan="comp.phoneme.list.length">{{ comp.phoneme.token }}</th>
                        </tr>
                        <tr>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <th>{{ irow.pron }}</th>
                            </template>
                        </tr>
                        <tr>
                            <td>Min-Max Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.min }}-{{ irow.max}}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Average Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.avg.toFixed(1) }}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.len }}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Percentage error(%)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.erate }}</td>
                            </template>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <audio id="pop-audioplayer" class="rr-voice" :src="comp.play.vpath" @ended="comp.gotEnded"></audio>
    </div>
</template>

<script>
import { reactive, onMounted, watch } from "vue";

import PitchChart from '@/components/Charts/PitchChart';
import IntensityChart from '@/components/Charts/IntensityChart';
import { useStore } from 'vuex';

export default {
    name: "PopDetail",
    components: {
        PitchChart,
        IntensityChart,
    },
    props:{ 
        modelValue: [Object, Array],
        control : [Object, Array],
        option : [Object, Array],
    },
    setup(props, { emit }) {
        const store = useStore()

        const comp = reactive({
            uidx : 0,
            view : { idx:0, show:'N', phonemes:[], result:[], text:'', hover:-1, vpath:'', avg_score:0, avg_grade:0, len_tot:0, words_cnt:0 },
            phoneme : { idx:-1, show:false, list:[], token:"" },
            pitch : { w:'538', h:'150', labels:[], datalist:[[], []] },      // pitch normalized
            pitch_o : { w:'538', h:'150', labels:[], datalist:[[], []] },    // pitch original
            intensity : { w:'538', h:'150', labels:[], datalist:[[], []] },  // intensity original
            zIndex : -9,
            audioplayer2 : null,
            play: { idx:0, vpath:"", status:0 },
            control : {
                // 분석 대상이 되는 원어민
                idxl : [],
                list : [],
                lens : [],
                pers : [],
                avgs : [],
                pitch : { dist:0, min:0, max:0 },
            },
            opts : {
                base : { best:10, good:20, average:30, fair:40, poor:'etc', pitch_weight:30 }
            },

            doInit:(iv)=>{
                if( comp.control.lens.length <= 0 ) return

                if( !iv.avg_score ) return

                comp.zIndex = 999

                comp.view.idx = iv.idx
                comp.view.phonemes = iv.phonemes
                comp.view.result = iv.result
                comp.view.text = iv.script
                comp.view.vpath = iv.vpath
                comp.view.avg_score = iv.avg_score
                comp.view.avg_grade = iv.avg_grade
                comp.view.len_tot = iv.len_tot
                comp.view.words_cnt = iv.words_cnt

                comp.view.show = 'Y'

                comp.view.best_match = iv.pitch_answer.best

                comp.makeChartData()
            },
            makeChartData:() => {
                let slist = comp.view.result
                let clist = comp.control.list
                let data_cnt = 0
                let best_idx = (comp.control.idxl.indexOf(comp.view.best_match))


                ////////////////////////////////////////////////////////////////
                // student pitch normalized add
                comp.pitch.labels = []
                comp.pitch.datalist = [{label:'Student Pitch', data:[]}]

                // student pitch normalized data add
                for(let i=0; i<slist.length; i++) {
                    let irow = slist[i]
                    comp.pitch.labels.push(irow['pron'])
                    comp.pitch.datalist[data_cnt]['data'].push(irow['pitch_fit'])
                }

                // native pitch normalized data add
                data_cnt++
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n pitch add
                        if( !comp.pitch.datalist[data_cnt] ) {
                            comp.pitch.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Pitch ',
                                data : []
                            }

                            if( i==best_idx ){
                                comp.pitch.datalist[data_cnt].label = 'Best Match'
                                comp.pitch.datalist[data_cnt].isBest = true
                            }
                        }
                        comp.pitch.datalist[data_cnt]['data'].push(jrow['pitch_fit'])
                    }

                    data_cnt++
                }



                ////////////////////////////////////////////////////////////////
                // student pitch original add
                comp.pitch_o.labels = []
                comp.pitch_o.datalist = [{label:'Student Pitch Ori', data:[]}]

                // student pitch original data add
                data_cnt = 0
                for(let i=0; i<slist.length; i++) {
                    let irow = slist[i]
                    comp.pitch_o.labels.push(irow['pron'])
                    comp.pitch_o.datalist[data_cnt]['data'].push(irow['pitch'])
                }

                // native pitch original data add
                data_cnt++
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n pitch add
                        if( !comp.pitch_o.datalist[data_cnt] ) {
                            comp.pitch_o.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Pitch O ',
                                data : []
                            }

                            if( i==best_idx ){
                                comp.pitch_o.datalist[data_cnt].label = 'Best Match'
                                comp.pitch_o.datalist[data_cnt].isBest = true
                            }
                        }
                        comp.pitch_o.datalist[data_cnt]['data'].push(jrow['pitch'])
                    }
                    data_cnt++
                }



                ////////////////////////////////////////////////////////////////
                // student intensity add
                comp.intensity.labels = []
                comp.intensity.datalist = [{label:'Student Intensity', data:[]}]

                // student intensity data add
                data_cnt = 0
                for(let i=0; i<slist.length; i++) {
                    let irow = slist[i]
                    comp.intensity.labels.push(irow['pron'])
                    comp.intensity.datalist[data_cnt]['data'].push(irow['intensity_fit'])
                }

                // native intensity data add
                data_cnt++
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n intensity add
                        if( !comp.intensity.datalist[data_cnt] ) {
                            comp.intensity.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Intensity ',
                                data : []
                            }
                        }
                        comp.intensity.datalist[data_cnt]['data'].push(jrow['intensity_fit'])
                    }

                    data_cnt++
                }
            },

            hideView:()=>{
                emit("close");

                setTimeout(() => {
                    comp.zIndex = -9

                    comp.deSelect()
                    comp.view.show = 'N'
                    comp.view.idx = ''
                    comp.view.phonemes = []
                    comp.view.result = []
                    comp.view.text = ''
                    comp.view.vpath = ''
                    comp.view.avg_score = 0
                    comp.view.avg_grade = 0
                    comp.view.len_tot = 0
                    comp.view.words_cnt = 0

                }, 500)

            },
            onHover:(j) => {
                comp.view.hover = j
            },

            mkClass:(ir, j)=>{
                let jr = ir.phonemes[j]
                return 'phonemes-' + j + ' ' + (!jr.grade?'':jr.grade)
            },
            onPlay:(o) => {
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    setTimeout(() =>{
                        comp.audioplayer2.play();
                    }, 200)
                }
            },
            gotEnded:() => {
                console.log('play done')
                comp.play.idx = 0
                comp.play.status = 0
            },
            onSelect:(j)=>{
                comp.phoneme.idx = j
                comp.phoneme.show = true
                comp.phoneme.token = comp.view.phonemes[j].token
                comp.phoneme.list = comp.view.phonemes[j].analysis
                // console.log(comp.phoneme.list)
            },
            deSelect:() => {
                comp.phoneme.idx = -1
                comp.phoneme.show = false
            }
        })


        watch(() => props.modelValue, (nVal) => {
            if( !nVal == false ){
                comp.doInit(nVal)
            }
        })

        watch(() => props.control, (nVal) => {
            if( !nVal == false ){
                comp.control = nVal
            }
        })

        watch(() => props.option, (nVal) => {
            if( !nVal == false ){
                comp.opts = nVal
            }
        })

        onMounted(() => {
            comp.audioplayer2 = document.getElementById("pop-audioplayer")
            comp.control = props.control
            comp.opts = props.option

            comp.uidx = store.state.user.idx
        })


        return { comp, props };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .modal {
        position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; z-index: -9;
        background: rgba(0,0,0,.3); flex-flow: column wrap; justify-content: center; align-items: center; opacity:0; transition : opacity 0.5s;
        &.open {
            z-index:990; opacity:1;
            .modal-close {
                position: absolute;
                z-index: 3;
            }
        }
        &-close {
            top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%;
            cursor:pointer;
        }
        &-pop {
            position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 5;
            background: #fff; border-radius: 4px; width: 100%; max-width: 600px; min-height: 100px; 
            padding:30px 20px;
            .close {
                position:absolute; top:-12px; right:-14px; width:20px; height:20px; border-radius:20px; cursor:pointer; font-size: 16px; line-height: 16px; color: #f0f0f0;
            }
        }
        &-body {
            text-align:left;
            .ex-box {
                word-break: break-all;
                font-size:1rem; color:#666; text-align:left; padding:10px; border:1px solid #c8c8c8;
                .tit {
                    padding:20px 0 5px; font-size:11px;
                }
                .btn {
                    display:inline-block; border:1px solid rgba(29, 166, 0, 1); border-radius:20px; width:16px; height:16px; font-size:13px; line-height:15px; padding:0; margin:0; text-align:center; color:#fff; background-color:rgba(29, 166, 0, 0.6); vertical-align:top; margin-top:2px; margin-left:6px;
                }
                .script {
                    .speech {
                        font-size:15px; margin-left:20px;
                        &:first-child {
                            margin-left:0;
                        }
                    }
                }
            }
            .result-box {
                .hover {
                    background-color:rgba(0,0,0,0.1)
                }
                .best { color:#4744f7; }
                .good { color:#1da600; }
                .average { color:#ffeb00; }
                .fair { color:#fab905; }
                .poor { color:#fc2415; }
                span {
                    font-size:11px;
                    > span {
                        font-size:18px; cursor:pointer;
                    }
                }
            }
            .chart {
                position:relative; width:100%; height:150px;
            }
        }
        .ex-pron {
            position:absolute; top:0; left:0; right:0; bottom:0; margin:auto;
            text-align:center; background-color:rgba(200,200,200,0.4); vertical-align: middle;
            .ex-box {
                position:relative; display:inline-block;
                vertical-align: middle; margin:50px auto 0; text-align:center;
                table {
                    border-radius:4px; background-color:#fff; box-shadow: 0px 0px 8px #999;
                    th {
                        padding:10px 0 6px;
                        border-bottom:1px solid #c8c8c8;
                    }
                    td {
                        padding:6px 10px 10px;
                    }
                }
                .btn-ex-close {
                    position:absolute; top:-20px; left:calc(50% - 10px); width:20px; height:20px; background-color:transparent; border:0; line-height:20px; padding:0; color:#fff; font-size:16px; text-shadow: rgb(0, 0, 0) 0 0 8px;
                }
            }
            .ex-bg {
                position:absolute; top:0; left:0; width:100%; height:100%;
            }
        }
    }
</style>
